// src/apis/materialMoveApi.ts
// PDA1071_R01 자재이동 API

import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { getData, postData } from "../utils/axios/serverHelper";
import type {
  PDA1071_R01SearchParams,
  PDA1071_R01HeaderDto,
  PDA1071_R01Dto,
  PDA1071_R01ScanResultDto,
  PDA1071_R01MoveRequest,
  PDA1071_R01MoveResultDto,
} from "src/containers/PDA/PDA1071_R01/PDA1071_R01Dto";

const baseUrl = `${config.apiUrl}/PDA1071_R01`;

/** 공정지시 목록 (search) */
export const searchWorkOrdersR02 = async (params?: PDA1071_R01SearchParams) => {
  const url = `${baseUrl}/search`;
  return await getData<ResponseDto<PDA1071_R01HeaderDto[]>>(url, { params });
};

/** 공정지시 목록 (refetch) */
export const refetchWorkOrdersR02 = async (params?: PDA1071_R01SearchParams) => {
  const url = `${baseUrl}/refetch`;
  return await getData<ResponseDto<PDA1071_R01HeaderDto[]>>(url, { params });
};

/** 공정지시 상세 + BOM 가이드 */
export const getWorkOrderDetailR02 = async (
  productWorkNo: string,
  warehouseCd?: string
) => {
  const url = `${baseUrl}/work/${productWorkNo}`;
  return await getData<ResponseDto<PDA1071_R01Dto>>(url, {
    params: warehouseCd ? { warehouseCd } : undefined,
  });
};

/** itemCd 스캔 검증 */
export const scanItemR02 = async (productWorkNo: string, scanValue: string) => {
  const url = `${baseUrl}/scan/${encodeURIComponent(productWorkNo)}/${encodeURIComponent(scanValue)}`;
  return await getData<ResponseDto<PDA1071_R01ScanResultDto>>(url);
};

/** 자재 이동 등록 */
export const moveMaterialsR02 = async (request: PDA1071_R01MoveRequest) => {
  const url = `${baseUrl}`;
  return await postData<PDA1071_R01MoveRequest, ResponseDto<PDA1071_R01MoveResultDto>>(
    url,
    request
  );
};
